import React from 'react';
import PropTypes from 'prop-types';

import { Dialog, LinearProgress } from 'material-ui';

const styles = {
  title: {
    paddingBottom: '1em',
    display: 'block',
    textAlign: 'center',
  },
};

const LoadingDialog = (props) => {
  const { title, ...rest } = props;

  return (
    <Dialog {...rest}>
      <span style={styles.title}>{title}</span>
      <LinearProgress color="#004f94" mode="indeterminate" />
    </Dialog>
  );
};

LoadingDialog.propTypes = {
  title: PropTypes.string,
};

export default LoadingDialog;



// WEBPACK FOOTER //
// ./src/components/LoadingDialog.js